import React from 'react'
import { Modal } from 'bootstrap'
import PropTypes from 'prop-types'

const CopyTextButton = ({ onClick, disabled, isCopied, cookieId = null }) => {
  const [modal, setModal] = React.useState(null)
  const exampleModal = React.useRef()

  const onClickExtend = () => {
    onClick()
    if(cookieId) {
      modal.show()
    }
  }

  const hideModal = () => {
    modal.hide()
  }

  React.useEffect(() => {
    if(cookieId) {
      setModal(
        new Modal(exampleModal.current)
      )
    }
  }, [cookieId])

  return (
    <>
      <button
        onClick={onClickExtend}
        type="button"
        className="ms-2 btn btn-sm btn-primary"
        disabled={disabled}
      >
        { isCopied
          ? <i className="fas fa-check-circle fs-4 me-2"/>
          : <i className="fas fa-file-alt fs-4 me-2"/>
        }
        Copy Text
      </button>
      {cookieId &&
      <div className="modal fade" ref={exampleModal} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Privacy Policy text copied</h5>
              <button type="button" className="btn-close" onClick={hideModal} aria-label="Close" />
            </div>
            <div className="modal-body">
              <p className='fw-bold'>
                The Cookie Declaration table is generated dynamically and cannot be copied as text. When using your Privacy
                Policy on the web page, copy-paste the Cookie Declaration report JavaScript code snippet
                (shown below, can also be found in the Installation tab of your banner settings) and insert it in the
                "Cookies" Privacy Policy section.
              </p>
              <div>
                <code>
                  &lt;script
                  type="text/javascript"
                  charSet="UTF-8"
                  data-cookiescriptreport="report"
                  src={`//report.cookie-script.com/r/${cookieId}.js`}
                  &gt;
                  &lt;/script&gt;
                </code>
              </div>

            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={hideModal}>Close</button>
            </div>
          </div>
        </div>
      </div>
      }
    </>
  )
}

CopyTextButton.propTypes  = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  isCopied: PropTypes.bool.isRequired,
  cookieId: PropTypes.string,
}

export default CopyTextButton